import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnumNames, Subscription } from '@parkupp/core'
import { ParkingService } from 'src/app/services/parking.service'

@Component({
    selector: 'app-client-subscription-card',
    templateUrl: './client-subscription-card.component.html',
    styleUrls: ['./client-subscription-card.component.scss'],
})
export class ClientSubscriptionCardComponent implements OnInit {
    EnumNames = EnumNames
    @Input() subscription: Subscription
    openAddPaymentMethod: boolean
    openPopup: boolean = false

    constructor(private router: Router, private parkingService: ParkingService) {}

    ngOnInit(): void {
        this.parkingService.get(this.subscription.parkingRef.id).subscribe((parking) => {
            this.subscription.$parking = parking
        })
    }

    onViewDetails() {
        this.router.navigate(['/client', this.subscription.merchantRef.id, 'subscription', this.subscription.$key])
    }

    onPaymentMethodClosed() {
        this.openAddPaymentMethod = false
    }

    showPaymentMethodPopup() {
        this.openPopup = true
    }
}
